import { render, staticRenderFns } from "./OutputPermissionForm.vue?vue&type=template&id=0546e76e"
import script from "./OutputPermissionForm.vue?vue&type=script&lang=js"
export * from "./OutputPermissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports